var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgSizeNormal = function SvgImgSizeNormal(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 221 148",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "img-size-normal_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m75.155 94.339-10.186 16.127a1 1 0 0 0 .845 1.534h20.372a1 1 0 0 0 .845-1.534L76.845 94.339a1 1 0 0 0-1.69 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m86.159 99.309-7.169 11.15a1 1 0 0 0 .842 1.541h14.336a1 1 0 0 0 .841-1.541l-7.168-11.15a1 1 0 0 0-1.682 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 92,
    r: 4,
    fill: "#000"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 147,
    x: 0.5,
    y: 0.5,
    stroke: "currentColor",
    rx: 7.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 57,
    y: 14,
    fill: "currentColor",
    rx: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 57,
    y: 64,
    fill: "currentColor",
    rx: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 57,
    y: 125,
    fill: "currentColor",
    rx: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 10,
    x: 70,
    y: 14,
    fill: "currentColor",
    rx: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 10,
    x: 70,
    y: 64,
    fill: "currentColor",
    rx: 1.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 10,
    x: 70,
    y: 125,
    fill: "currentColor",
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M57 32.5a1.5 1.5 0 0 1 1.5-1.5h150a1.5 1.5 0 0 1 1.5 1.5v22a1.5 1.5 0 0 1-1.5 1.5h-150a1.5 1.5 0 0 1-1.5-1.5zM0 8a8 8 0 0 1 8-8h37a1 1 0 0 1 1 1v146a1 1 0 0 1-1 1H8a8 8 0 0 1-8-8z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 35,
    x: 57,
    y: 82,
    fill: "currentColor",
    mask: "url(#img-size-normal_svg__a)",
    rx: 2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgSizeNormal);
export default ForwardRef;